/** "full" is the standard page layout: full width, padded, with a sticky PageHeader. */
export type LayoutType = "bare" | "fullheight" | "standard" | "fullheight-no-padding" | "full";
